import { IRaxDataCtx } from './types';

export const raxInitialValues: IRaxDataCtx = {
  value: null,
};
